// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class PersonResource extends Resource {
    basePath: string = 'clients/clients/person/';

    objectPath: string = 'clients/clients/person/{ident}/';
}
